export default {
  isShrunk: false,
  showLandingMenu: false,
  isPaymentHistoryOpen: false,
  isPromptOpen: false,
}
